import { useContext, useEffect, useState } from "react";
import {
  DropdownsContext,
  DropdownsProvider,
} from "../../../../../contexts/DropdownsContext";
import "./InventoryManagementReturn.css";
import Dropdowns from "../../../../../components/Dropdowns/Dropdowns";
import { DropdownProvider } from "../../../../../contexts/DropdownGlobalDataContext";
import Input from "../../../../../components/Inputs/Input";
import { partReturn } from "../../../Services/partRequestService";
import { useSnackBar } from "../../../../../hooks/useSnackBar";
import { HTTP_RESPONSE_CODES } from "../../../../../globals/globals";
const mainTransaction = {
  siteId: null,
  rackId: null,
  shelfId: null,
  binId: null,
  conditionId: null,
  qty: 0,
};
const dropdownNames = {
  19: "siteId",
  79: "rackId",
  97: "shelfId",
  99: "binId",
  96: "conditionId",
};
const InventoryManagementReturnForm = ({
  data,
  onClose,
  part,
  saveSuccess,
}) => {
  const dropdownIds = [19, 79, 97, 99, 96];
  const {
    dropdownsData,
    setDropdownsData,
    dropdownDefaultOptions,
    setDropdownIds,
  } = useContext(DropdownsContext);
  const { successMsg, warningMsg, infoMsg } = useSnackBar();
  const [forceDependency, setForceDependency] = useState([]);
  const [displayForm, setDisplayForm] = useState(false);
  const [values, setValues] = useState({ ...mainTransaction });
  const [displayView, setDisplayView] = useState(false);
  const [activeTransaction, setActiveTransaction] = useState(null);

  const hideFieldsWhenDisabled = new Set([
    "Site",
    "Shelf",
    "Rack",
    "Bin",
    "Part Condition",
  ]);
  const [defaults, setDefaults] = useState({});

  useEffect(() => {
    if (data) {
      if (data.length > 1) {
        setDisplayView(true);
      } else if (data.length > 0) {
        setActiveTransaction(data[0]);
      }
    }
  }, [data]);

  useEffect(() => {
    if (activeTransaction) {
      setValues((prev) => {
        return {
          ...prev,
          ...{
            siteId: activeTransaction.siteId,
            rackId: activeTransaction.rackId,
            shelfId: activeTransaction.shelfId,
            binId: activeTransaction.binId,
            qty: 0,
          },
        };
      });
      setDefaults((prev) => {
        return {
          ...prev,
          ...{
            siteId: activeTransaction.siteId,
            rackId: activeTransaction.rackId,
            shelfId: activeTransaction.shelfId,
            binId: activeTransaction.binId,
            qty: 0,
          },
        };
      });
    } else {
      setValues({ ...mainTransaction });
    }
  }, [activeTransaction]);

  useEffect(() => {
    setDropdownIds(dropdownIds);
    setForceDependency([
      {
        id: 14,
        parentSqlstatementColumnName: "id",
        childDropdownId: 19,
        childSqlstatementColumnName: "location_id",
        childSqlstatementParameterName: "locationId",
        contextId: 1,
        value: [part?.orginalInfo?.location_id],
      },
    ]);
    setDefaults({ ...values });
  }, [data]);

  useEffect(() => {
    if (dropdownsData && dropdownsData.length > 0) {
      setDisplayForm(true);
    }
  }, [dropdownsData]);
  const updateDropdown = (dropdownId, parentValues, dependenciesToUpdate) => {
    setDropdownsData((prevDropdowns) =>
      prevDropdowns.map((filter) => {
        if (filter.id === dropdownId) {
          return {
            ...filter,
            parentValues,
            dependenciesToUpdate,
            reload: true,
          };
        }
        return filter;
      })
    );
  };

  const handleDropdownValue = (value, name, data) => {
    changeValue({ target: { name, value: value[data], completeValue: value } });
    setDefaults((prev) => ({
      ...prev,
      ...{ [name]: " " },
    }));
  };

  const isEnabledToSend = () => {
    if (activeTransaction) {
      return (
        values["siteId"] &&
        values["rackId"] &&
        values["conditionId"] &&
        values["qty"] > 0
      );
    } else {
      return false;
    }
  }
  const resetDropdownsReload = () => {
    setDropdownsData((filterState) => {
      if (filterState.length > 0) {
        return filterState.map((e) => {
          if (e.reload) {
            return { ...e, reload: false };
          }
          return e;
        });
      }
      return filterState;
    });
  };
  const changeValue = (e) => {
    const { name, value, completeValue } = e.target;
    setValues((prev) => {
      return {
        ...prev,
        ...{ [name]: value },
      };
    });
  };
  const handlerSave = () => {
    if (!isEnabledToSend()) {
      return;
    }
    let payload = {
      serializedPartId: part?.serializedPartId,
      siteId: values["siteId"],
      locationId: part?.orginalInfo?.location_id,
      rackId: values["rackId"],
      shelfId: values["shelfId"],
      binId: values["binId"],
      quantityToReturn: values["qty"],
      partId: part?.orginalInfo?.part_id,
      companyId: part?.orginalInfo?.company_id,
      uomId: part?.orginalInfo?.uom_id,
      internalBatch: part?.orginalInfo?.internal_batch,
      conditionId: values["conditionId"],
      transactionParentId: part?.orginalInfo?.last_transaction_id,
      issueId: activeTransaction?.issueId,
      unitCost: part?.orginalInfo?.unit_cost,
    };
    partReturn(payload)
      .then((response) => {
        if (response.data.responseCode === HTTP_RESPONSE_CODES.UPDATED) {
          successMsg("Part Was returned successfully");
          saveSuccess();
          onClose();
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {});
  };
  return (
    displayForm && (
      <div className="inventory-return-dialog-container">
        <div className="inventory-return-dialog-body">
          {displayView && (
            <div className="inventory-return-dialog-left-side">
              <div className="inventory-return-dialog-part-header">
                <b>WP</b>
                <b>TaskCard</b>
                <b>QTY Issued</b>
              </div>
              {data.map((item, index) => {
                return (
                  <div
                    className={`inventory-return-dialog-part-info ${
                      activeTransaction?.transactionId === item.transactionId
                        ? "active"
                        : ""
                    }`}
                    key={index}
                    onClick={() => {
                      setActiveTransaction(item);
                    }}
                  >
                    <p>{item.workPackage}</p>
                    <p>{item.taskCard}</p>
                    <p>
                      {item.quantityIssued}{" "}
                      {item.uom}
                    </p>
                  </div>
                );
              })}
            </div>
          )}
          <div className="inventory-return-dialog-right-side">
            <b>Details - WP{activeTransaction?.workPackage}</b>
            <Dropdowns
              context={{
                dropdownsData,
                setDropdownsData,
                setDropdownIds,
                dropdownDefaultOptions,
              }}
              required={true}
              disabled={!activeTransaction}
              updateDropdown={updateDropdown}
              resetDropdownsReload={resetDropdownsReload}
              hideWhenDisabled={hideFieldsWhenDisabled.has(dropdownNames[19])}
              key={19}
              onOptionSelect={(value, data) =>
                handleDropdownValue(value, dropdownNames[19], data)
              }
              forceDependency={forceDependency}
              showPagination={false}
              data={dropdownsData.find((e) => e.id === 19)}
              preSelectValue={defaults?.[dropdownNames[19]]}
            />
            <Dropdowns
              context={{
                dropdownsData,
                setDropdownsData,
                setDropdownIds,
                dropdownDefaultOptions,
              }}
              required={true}
              disabled={!activeTransaction}
              updateDropdown={updateDropdown}
              resetDropdownsReload={resetDropdownsReload}
              hideWhenDisabled={hideFieldsWhenDisabled.has(dropdownNames[79])}
              key={79}
              onOptionSelect={(value, data) =>
                handleDropdownValue(value, dropdownNames[79], data)
              }
              showPagination={false}
              data={dropdownsData.find((e) => e.id === 79)}
              preSelectValue={defaults?.[dropdownNames[79]]}
            />
            <Dropdowns
              context={{
                dropdownsData,
                setDropdownsData,
                setDropdownIds,
                dropdownDefaultOptions,
              }}
              required={false}
              updateDropdown={updateDropdown}
              disabled={!activeTransaction}
              resetDropdownsReload={resetDropdownsReload}
              hideWhenDisabled={hideFieldsWhenDisabled.has(dropdownNames[97])}
              key={97}
              onOptionSelect={(value, data) =>
                handleDropdownValue(value, dropdownNames[97], data)
              }
              showPagination={false}
              data={dropdownsData.find((e) => e.id === 97)}
              preSelectValue={defaults?.[dropdownNames[97]]}
            />
            <Dropdowns
              context={{
                dropdownsData,
                setDropdownsData,
                setDropdownIds,
                dropdownDefaultOptions,
              }}
              required={false}
              updateDropdown={updateDropdown}
              disabled={!activeTransaction}
              resetDropdownsReload={resetDropdownsReload}
              hideWhenDisabled={hideFieldsWhenDisabled.has(dropdownNames[99])}
              key={99}
              onOptionSelect={(value, data) =>
                handleDropdownValue(value, dropdownNames[99], data)
              }
              showPagination={false}
              data={dropdownsData.find((e) => e.id === 99)}
              preSelectValue={defaults?.[dropdownNames[99]]}
            />
            <div className="inventory-return-dialog-footer">
              <Dropdowns
                context={{
                  dropdownsData,
                  setDropdownsData,
                  setDropdownIds,
                  dropdownDefaultOptions,
                }}
                required={true}
                updateDropdown={updateDropdown}
                disabled={!activeTransaction}
                resetDropdownsReload={resetDropdownsReload}
                hideWhenDisabled={hideFieldsWhenDisabled.has(dropdownNames[96])}
                key={96}
                onOptionSelect={(value, data) =>
                  handleDropdownValue(value, dropdownNames[96], data)
                }
                showPagination={false}
                data={dropdownsData.find((e) => e.id === 96)}
                preSelectValue={defaults?.[dropdownNames[96]]}
              />
              <b>QTY</b>
              <Input
                style={{ gridColumn: "span 1" }}
                onChange={changeValue}
                name="qty"
                disabled={!activeTransaction}
                disableAutocomplete={true}
                limit={activeTransaction?.quantityIssued}
                isNumeric={true}
                placeholder={"0"}
                label={""}
                value={values["qty"]}
              />
            </div>
          </div>
        </div>

        <div className="inventory-return-dialog-buttons">
          <button className={`pr-ok ${!isEnabledToSend() ? 'disabled' : ''}`} onClick={handlerSave}>
            Ok
          </button>
          <button className="pr-cancel" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    )
  );
};
export const InventoryManagementReturn = ({
  data,
  onClose,
  part,
  saveSuccess,
}) => {
  return (
    <div className="inventory-management-return-component">
      <div className="inventory-return-dialog-header">
        <div className="header-left-side">
          <div className="header-title">
            <i className="icon-return"></i>
            <h2>Part Return</h2>
          </div>
        </div>
        <button className="outlined icon small-size" onClick={onClose}>
          <i className="icon-cross"></i>
        </button>
      </div>
      <hr />
      <DropdownsProvider>
        <InventoryManagementReturnForm
          data={data}
          part={part}
          onClose={onClose}
          saveSuccess={saveSuccess}
        ></InventoryManagementReturnForm>
      </DropdownsProvider>
    </div>
  );
};
